import TableStyles from "../../styles/TableStyles.css";
import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...TableStyles,
  ...CommonStyles,

  globalHeader: {
    display: "flex",
    background: "#292929",
    alignItems: "center",
    zIndex: "8",
    position: "relative",
    padding: "13px 5px",
  },
  globalBlockCreateBox: {
    marginBottom: "10px",
    "& > div": {
      padding: "5px 20px",
      display:"flex",
      width:"100%",
      boxSizing: "border-box",
    alignItems: "center",
    "& > span":{
      margin:" 0 10px 0 0",
    fontSize: "12px",
    color: "#d7d4d4",
    }
    },  
    "& .MuiTextField-root":{
      width:"100%",
    },
   
  },
  roledividerMargin: {
    margin: "10px 10px  20px 10px ",
  },
  globalModuleWrap: {
    paddingTop: "25px",
  },

  moduleEdit: {
    float: "right",
    minWidth: "30px",

    background: "#212121",
    padding: "8px",
  },
  sidBarWrap: {
    minWidth: "480px",
    position: "relative",
    overflow: "hidden",
    height: "100%",
    background: "#303030",
  },

  sidBarInnerWrap: {
    left: " 0",
    width: "100%",
    height: "calc(100% - 0px)",
    position: "absolute",
    overflowX: "hidden",
    overflowY: "auto",
  },
  sidBarInnerContents: {
    padding: "20px",
  },
  tableMainView: {
    width: "100%",
    height: "calc(100% - 170px)",
    overflow: "auto",
    position: "absolute",
    background: "#000",
    marginTop: "0px",
    "& .MuiAvatar-square":{
      width:"30px",
      height:"30px",
      background: "#d8d8d5",
      borderRadius: "3px",
    },
    "& .playTrack": {
      top: "15px",
  }
  },


  clearanceFormHeader: {
    background: "#005371",
    fontSize: "1em",
    padding: "20px",
    "& h1": {
      marginTop: "0",
      fontSize: "1.3em",
      fontWeight: "400",
      marginBottom: "0",     
    },
  },
  clearanceFormHeaderDetails: {
 fontSize: "0.75em",
    "& span.titleSpan": {
      textTransform: "uppercase",
      minWidth: "145px",
      display: "inline-block",
    },
    "& .MuiCircularProgress-colorPrimary": {
      color: "white",
      width: "20px !important",
      height: " 20px !important",
    },
    marginBottom: "5px",
    textOverflow: "ellipsis",
    paddingRight: "10px",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  clearanceButtonMargin: {
    margin: "1px 5px  0 0",
    borderRadius: "5px",
    "& svg":{
      fontSize:"34px",
    },
    "& .MuiBadge-dot": {
      height: "14px",
      padding: "0",
      minWidth: "14px",
      borderRadius: "50%"
   }
  },
  clearanceSign: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "50%",
    margin: "5px 10px 5px 0px",
    display: "inline-block",
    verticalAlign: "middle",
  },
  inlineWizardRun:{
    background:"red",
  },
  clearanceList: {
    "&  .MuiMenu-list": {
      minWidth: "230px",
      maxWidth: "230px",
    },
    "& .MuiOutlinedInput-root": {
      width: " 100%",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      padding: "6px 32px 8px  8px!important",
      marginTop: "0",
      "& > div": {
        margin: "0px 9px 0px 10px",
      },
    },
  },
  addTrackML:{
    fontSize:"16px",
    margin:"20px 0 10px 0",
    color:"#ffb932",
    fontWeight:"bold",

  },
  clearanceOverride: {
    padding: "0 15px",
    marginBottom: "8px",
    "& label": {
      fontSize: "12px",
      margin: "8px 0 7px 0",
      display: "block",
      borderTop: "1px solid #676767",
      paddingTop: "10px",
    },
    "& .MuiSelect-select":{
      paddingTop: "4px",
    paddingBottom: "4px",
    maxWidth:"150px",
    }
  },
  buttonDivider:{
    background: "#676767",
    height:"1px",
    border:"none",
  },
 allocatToUser:{
  borderTop: "1px solid #676767",
  padding: "0 15px",
  marginBottom: "16px",
    "& .MuiAutocomplete-inputRoot":{
    padding: "0 0 0 5px",
    fontSize: "12px",
    },
    "& label": {
      fontSize: "12px",
      margin: "5px 0 8px 0",
      display: "block",
      paddingTop: "10px",
    },
    "& .MuiSelect-select":{
      paddingTop: "4px",
    paddingBottom: "4px",
    maxWidth:"150px",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined":{
      padding: "8px 10px !important",
    marginTop: "0",    
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
  },
  clearanceIcon: {
    marginRight: "8px",
    fontSize: "18px",
    "& path":{
      stroke:"#fff",  
    }
  },
  clearanceLivePopup: {
    minWidth: "450px",
    padding: "5px 0px 15px 0px",
    "& .MuiDialogTitle-root": {
      margin: "0",
      padding: "8px 24px",
      borderBottom: "1px solid #616161",
      paddingBottom: "5px",
      marginBottom: "15px",
    },
    "& .MuiDialogActions-root": {
      paddingRight: "15px",
    },
    "& .MuiCircularProgress-colorPrimary": {
      color: "white",
      width: "20px !important",
      height: " 20px !important",
    },
  },
  clearanceLiveTrackName: {
    fontSize: "14px",
    padding: "0 25px",
    whiteSpace: "pre-wrap",
    maxWidth: "350px",
  },
  tableFilterInput: {
    width: "100%",
    "& input": {
      borderRadius: "4px !important",
      padding: "8px",
       fontSize:"0.8em",
      background: "#4A4949",
    },
    "& div": {
      borderRadius: "4px !important",
      width: "100%",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px !important",
    },
    "& label": {
      fontSize: "12px",
      top: " -10px !important",
      left: "20px",
    },
    "& .MuiInputLabel-shrink": {
      top: "2px !important",
      left: "0px",
    },
    "& .Mui-focused": {
      color: "#fff !important",
    },
  },
  trackNotesIcon: {
     fontSize:"1em",
    color: "green",
  },
  trackNotesIconEmpty: {
    color: "gray",
  },
  varientClass:{
    background:"red",
  },
  globalCreateErrWrapper:{
    margin: "6px 0 10px 38px",
  color:"#FFD1D1   !important",
  fontSize:"12px",
  },
  clearanceDeadline:{
    "& .MuiOutlinedInput-input":{
    padding:"9px 14px",
    fontSize:"12px",
  },
  width:"100%",
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor:"#46af22",
  }
  },
  genreDropdownContainer:{
    marginLeft: "20px",
  },
  clearanceFormLabels:{
  "& > div":{
    display:"flex",
  },
    "& .genreLableSpan":{
      marginLeft:"0 !important",
    },
    "& .MuiTextField-root":{
      // marginRight:"10px",
    },
    "& textarea":{
      color: "#fff",
    width:" 100%",
    border: "1px solid #4f7f94",
    resize: "none",
    padding: "10px",
    fontSize: "0.8em",
    maxWidth: "100%",
    background: "#1a5974",
    boxSizing: "border-box",
    maxHeight: "220px",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif , 'Segoe UI', 'Roboto', 'Oxygen'",
    borderRadius: "3px",
    outline:"none",
    "&:focus":{
      borderColor: "#46af22 !important",
    },
    "&:hover":{
      borderColor: "#46af22 !important",
    },
    }
  },
  tableMaxHeight:{
    maxHeight:"280px",
    minHeight:"280px",
    "& .Mui-selected td":{
      background: "#b0cdea !important",
      color:"#000  !important"
    },
    "& .MuiCircularProgress-colorPrimary":{
      color: "green",
      width: "40px!important",
      height: "40px!important",
      margin:"40px auto",
      position: "absolute",
      left: "0",
      right: "0",
  },
  },
  mainEditSynopsis:{
    "& .MuiTextField-root":{
      minWidth:"inherit",
    },
    "& .MuiTextField-root":{
      // minWidth:"140px",
      // maxWidth:"544px",
    },
  },
  genreSelectBox:{
    margin:"0",
    width: "100%",
    overflow: "hidden",
    "&:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22",
    }
  },
  genreAutoSelectBox:{
    margin:"0",
    width: "100%",
    background: "#19688a",
    "&:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22",
    },
    "& .MuiOutlinedInput-root":{
      padding: "0",
      fontSize: "12px",
    },
    "& input":{
      background:"#19688a",
      paddLeft:"15px !important",
    }
  },
  justifyEnd:{
    justifyContent:" flex-end",
  },
  editModeDiv:{
    background: "#004963",
    padding: "10px 10px 5px 10px",
    marginBottom: "12px",
    borderRadius:"4px",
    width:"100%",
  },
  clearanceEditTitleMain:{
    display:"flex",
    margin:"8px 20px 15px 0px",
    alignItems:" flex-start",
  },
  mainEditWrapper:{
    width:"100%",
  },
  clearanceEditTitle:{  
    marginBottom:"5px",
    "& > div":{
      display:"flex",
      alignItems: "center",
      marginBottom: "10px",
      "&  > div.seperator":{
        margin:"0 5px",
      }
    },
    "& input":{
      background:"#1A5974",
    },
    "& .MuiSelect-selectMenu": {
      paddingRight:" 32px",
      background: "#19688a",
      paddingTop: "7px",
      paddingBottom: "6px",
      textAlign:"left", 
    },
    "& label.genreLableSpan":{
      whiteSpace: "nowrap",
    margin: "0",
    alignItems: "inherit",
    textTransform: "uppercase",
    fontSize: "11px",
    minWidth: "95px",
    }
  },
 
  globalCreateSaveButton: {
    background: "#0C853E",
    boxShadow: "none",
    color: "#fff",
    border:"1px solid #0C853E",
    textTransform: "none",
    fontWeight: "400",
    margin: "0px",
    padding:"5px 15px",
    fontSize:"0.75em",
    "&:hover": {
        background: "#000",
        color: "#29D211",
        border:"1px solid #403f3f",
    },
    "& .MuiCircularProgress-colorPrimary":{
      width: "13px !important",
      height: "13px !important",
      color: "#fff !important",
      marginLeft: "5px !important",
    },
  },
  clearanceHelp:{
    display:"flex",
    "& .helpTooltip":{
      position:"relative !important",
    },
    "& .MuiAutocomplete-hasPopupIcon":{
      width:"100%",
    }
  },
  clearanceTitleMsgContainer:{
    display:"flex",
    alignItems: "flex-start",
 
  },
  clearanceFormStatus:{
    "& span":{
      display: "inline-block",
       fontSize:"1em",
      fontWeight: "400",
      verticalAlign: "middle",
      marginBottom: "0",
      marginRight:"5px",
      "& span":{
        marginRight:"10px",
      }
    },  
    fontSize: "0.95em",
    marginRight:"30px",
    display:"inline-block",
    verticalAlign: "middle",
 
  },
  workflowSelectBox:{
    maxWidth:"160px",
    "& .MuiSelect-select":{
      padding:"8px 32px 8px 10px",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined":{    
    fontSize: "1em !important",    
    }
  },

  allocateWrapperSpan:{
    display:"block",
    margin:"0",
    padding:"15px 0 0px 15px",
    borderTop:"1px solid #5a5a5a",
    fontSize:"0.8em",
  },
  allocateWrapperSpanAddMarginTop:{
    marginTop:"15px",
  },
  allocateWrapper:{
    padding:"10px 0px",
    fontSize:"1em",
    minWidth: "200px",
    minWidth:"200px",
    "& .helpTooltip":{
      position:"relative !important",
    },
    "& > span":{
      display:"block",
      marginBottom:"5px",
    },
    "& .MuiAutocomplete-popupIndicator":{
      padding:"0 !important",   
      marginTop: "2px",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22",
    },
    "& input":{
      fontSize:"12px",
      padding:"0px !important",
    },
    "& .MuiOutlinedInput-root":{
      width: "100%",
      "& .MuiSelect-select":{
        paddingTop: "10px",
        paddingBottom: "10px"
      }
    }
  },
  searchWrapper:{
    display:"flex",
    alignItems:"center",
    marginBottom:"20px",
    "& .MuiTextField-root":{
      width: "50%",
      marginRight: "10px",
    },
    "& .MuiOutlinedInput-input":{
    minHeight: "18px",
    padding:"8px 32px 8px 10px",
  
    },
    "& .MuiOutlinedInput-root":{
      // marginRight:" 10px",
    },
    "& button":{
      height:"35px",
      margin:"0"
    }
  },
  addcustomTrackAllDropdown:{
    margin:"0 10px",
    "& > div":{
      padding:"8px 10px",
    }
  },
  noData:{
    display:"block",
    textAlign:"center",
    padding:"10px",
    fontSize: "12px",
    position: "absolute",
    left: "0",
    right: "0",
    top:"130px"
  },
  relativeDiv:{
    position:"relative",
    "& .MuiTableBody-root > div":{}
  },
  tracksPagination:{
    "& .MuiTablePagination-input":{
      marginRight:"12px",
      marginLeft: "0px",
    },
    "& .MuiTablePagination-actions":{
      marginLeft: "10px",
    },
    "& .MuiToolbar-gutters":{
      paddingLeft: "0px",
    },
    "& .MuiSelect-select":{
      background:"#5d5d5d",
      borderRadius: "3px",
    },
    "& .Mui-focused .MuiSelect-select":{
      background:"#807f7f",
    },
    "& .MuiTablePagination-toolbar ":{
      paddLeft:"0",
      paddingTop: "5px",
    }
  },
  searchPRSWrapper:{
    display:"flex",
    alignItems:"center",
    marginBottom:"15px",
    "& .MuiTextField-root":{
      width: "100%",
    },
    "& .MuiOutlinedInput-input":{
    minHeight: "18px",
    padding:"8px 32px 8px 10px",
  
    },
    "& .MuiOutlinedInput-root":{
      marginRight:" 10px",
    },
    "& button":{
      height:"35px",
      margin:"0"
    },
    "& .MuiInputLabel-shrink": {
      top: "2px !important",
      left: "0px",
      color:"#fff"
    },
    "& label": {
      fontSize: "0.75em",
      top: " -10px !important",
      left: "0px",
      textTransform: "none",
    },
    "& > div":{
      display:"flex",
    }
  },
  progressnew:{
    color: "green",
    width: "40px!important",
    height: "40px!important",
    margin:"40px auto",
    position: "absolute",
    left: "0",
    right: "0",
    top:"120px"
  },
  prsButton:{
    background: "#0f79ad",
    color: "#fff",
    borderColor: "#0f79ad",    
    "&:hover":{
      background:"#1b8dc5",
      borderColor: "#0f79ad",   
      color: "#fff", 
    }
  },
  displayResults:{
    color:"#e2e2e2",
    fontSize:"0.8em",
    padding:"5px 0 15px 0",
    "& span":{
      color:"#7ed0ff",
      fontWeight:"500"
    }
  },
  prsImported:{
     "& label":{
       color:"#0fadfb",
     }
  },
  chipsContainer:{
    width:"100%",
    "& .MuiFormControl-root":{
      width:"100%",
      background: "#2d2d2d",
    },
    "& .MuiOutlinedInput-root":{
      padding:"0",
      background: "#2d2d2d",
    },
    "& .MuiOutlinedInput-input":{
      margin:" 0",
      background: "#2d2d2d",
    },
    "& .MuiChip-root":{
      margin: "5px",
  },
  },
  gridOverFlowContainer:{
    overflow: "auto",
    height: "390px",
  },
  resetDataButton:{
    marginLeft:"10px !important",
  },
  addllDropdown:{

    "& .MuiOutlinedInput-input":{
      background:"#5d5d5d",
      border: "none !important",
      "&:hover":{
        background:"#868686",
        border:"none",
        borderRadius:"3px",
      },
      "&:focus":{
        background:"#868686",
        border:"none",
        borderRadius:"3px",
      }
    },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none !important",
        borderWidth:" 0px !important",
        borderRadius:"3px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",     
  }
  },
  customErrorAlign:{
    textAlign:"right",
    paddingRight: "12px",
    paddingTop: "0px",
  }
});
